import { MediaType, type Image, type Media, type Video } from './types';

export const imagesMapper = (images?: Image[]): Media[] => {
	return images?.map(({ src }) => ({ type: MediaType.IMAGE, src })) ?? [];
};

export const videosMapper = (
	videos: Video[] | null | undefined,
	fallbackThumbnail?: Image,
): Media[] => {
	if (videos) {
		return videos.map(({ original_url, hls_url, thumbnail }) => ({
			type: MediaType.VIDEO,
			src: hls_url || original_url,
			poster: thumbnail ? thumbnail : fallbackThumbnail?.src,
		}));
	} else return [];
};
